import { initialState } from "reducers/Reports/State";
/**
 * @description create the menu labels list
 * @param reportsList array -  all the reports that are come from API 
 * @returns menuLabel array - return the menu labels list
 */
export const setMenuLabels = (reportList: any) => {
  try {
    let labels: any = [];
    reportList?.map((item: any, index: number) => {
      labels.push({ key: index, label: item.group });
    });

    const uniqueLabels = labels.filter(
      (value: any, index: any, self: any) =>
        index === self.findIndex((t: any) => t.label === value.label)
    );

    const updatedMenuLabels = [...uniqueLabels];
    updatedMenuLabels.unshift({ key: "-1", label: "All" });

    return {
      ...initialState.menuLabels,
      menuLabels: updatedMenuLabels,
    };
  } catch (error) {
    return initialState.menuLabels;
  }
};
